import { render } from "./component-archive-date.vue?vue&type=template&id=2416dda6"
import script from "./component-archive-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-archive-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-archive-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2416dda6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2416dda6', __exports__)) {
    api.reload('2416dda6', __exports__)
  }
  
  module.hot.accept("./component-archive-date.vue?vue&type=template&id=2416dda6", () => {
    api.rerender('2416dda6', render)
  })

}


export default __exports__